import { ROLE_EMOJIS } from '@repo/sdk'

import type { GameStatusData } from '@/lib/types'

type Translate = (
  key: string,
  params?: Record<string, string | number>,
) => string

export function openingAllocationLines(
  data: GameStatusData,
  t: Translate,
): string[] {
  const own = data.humanPlayer
  if (
    !own
    || !['in_progress', 'paused'].includes(data.game.status)
    || data.viewer.mode !== 'owner'
    || data.viewer.perspectiveSeatId !== own.id
    || !data.viewer.ownedSeatIds.includes(own.id)
  ) {
    return []
  }

  const ownSeat = data.players.find(
    seat => seat.id === own.id && seat.position === own.position,
  )
  if (!ownSeat)
    return []

  const lines = [t('play.openingAllocation.identity', {
    name: ownSeat.name,
    role: t(`game.${own.role}`),
    seat: own.position,
  })]
  const board = data.roleBoard
  if (board && board.viewerSeatId !== own.id)
    return lines

  const seatIdentity = (
    seat: typeof ownSeat,
    role: typeof own.role,
  ) => {
    const emoji = role in ROLE_EMOJIS
      ? ROLE_EMOJIS[role as keyof typeof ROLE_EMOJIS]
      : ''
    return t('play.openingAllocation.seatIdentity', {
      name: seat.name,
      role: `${emoji}${t(`game.${role}`)}`,
      seat: seat.position,
    })
  }
  const teammateFacts = board
    ? board.seats.flatMap((fact) => {
        if (fact.state !== 'known' || fact.source !== 'evil_teammate')
          return []
        return [{ seatId: fact.seatId, role: fact.role }]
      })
    : (data.openingKnownTeammates ?? [])
  const teammates = teammateFacts.flatMap((fact) => {
    if (fact.seatId === own.id)
      return []
    const seat = data.players.find(player => player.id === fact.seatId)
    return seat ? [seatIdentity(seat, fact.role)] : []
  })
  if (teammates.length) {
    lines.push(t('play.openingAllocation.team', {
      self: seatIdentity(ownSeat, own.role),
      teammates: teammates.join(t('play.openingAllocation.teamSeparator')),
    }))
  }

  return lines
}
